import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        lease_templates: {data: [], current_page: 1, total: 0, per_page: 10},
        lease_template: {},
        loading: false,
    },
    getters: {
        lease_templates: state => state.lease_templates,
        lease_template: state => state.lease_template,
        loading: state => state.loading,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val;
        },
        setLeaseTemplates(state, data) {
            state.lease_templates = data;
        },
        setLeaseTemplate(state, data) {
            state.lease_template = data;
        },
    },
    actions: {
        async getLeaseTemplates({commit}, filters) {
            commit("setLoading", true);
            try {
                const response = await api.getLeaseTemplates(filters);
                commit("setLeaseTemplates", response?.data);
                commit("setLoading", false);
            } catch {
                ElMessage.error("Failed to fetch lease templates");
            } finally {
                commit("setLoading", false);
            }
        },
        async createLeaseTemplate({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createLeaseTemplate(data);
                ElMessage.success('Template created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }

        },
        async editLeaseTemplate({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.editLeaseTemplate(data);
                ElMessage.success('Template created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async deleteLeaseTemplate({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.deleteLeaseTemplate(data);
                ElMessage.success('Template removed successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async getLeaseTemplateById({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                const response = await api.getLeaseTemplateById(data);
                ElMessage.success('Template fetched successfully!');
                commit('setLeaseTemplate', response)
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        }
    },
};
